import z from 'zod'
import {
  accountingIntegrations,
  httpIntegrations,
  publicApiIntegrations,
} from '@omnea-app/packages/universal/integrations/globalIntegrations'

export const SupplierRemoteTypeSchema = z.enum([...accountingIntegrations, ...publicApiIntegrations, ...httpIntegrations])
export type SupplierRemoteType = z.infer<typeof SupplierRemoteTypeSchema>
